<style lang="less" scoped>
</style>

<template>
  <div id="viewer">
    <ScaleBox></ScaleBox>
  </div>
</template>

<script>
import ScaleBox from '../assembly/ScaleBox.vue'
export default {
  components: {ScaleBox},
  data()
  {
    return {
      viewer: '',
      imgurl1: require('../../../../static/panorama/1.jpg'),
      imgurl2: require('../../../../static/panorama/2.jpg'),
      imgurl3: require('../../../../static/panorama/3.jpg')
    }
  },
  mounted()
  {
  },
  methods:
  {
  }
}
</script>





// WEBPACK FOOTER //
// src/plugins/app/project/PanoramicView.vue